import React, { Component } from 'react'
import Radium from 'radium'

class SearchBar extends Component {

  state = {
    search: ''
  }

  setCallback = (object) => {
    this.props.callbackFromParent(object)
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value}, () => {
      this.setCallback(this.state.search)
    })
  }

  render() {
    return (
      <div>
        <form>
          <input
            type="text"
            name="search"
            style={inputStyle}
            value={this.state.search}
            placeholder="Search..."
            size="25"
            onChange={this.onChange}
          />
        </form>
      </div>
    )
  }
}

const inputStyle = {
  fontSize: '16px',
  borderRadius: '4px',
  height: '36px',
  fontFamily: 'Avenir',
  padding: '10px',
  margin: '10px 0px',
}

export default Radium(SearchBar)
